import { render, staticRenderFns } from "./tabCustomerTicketing.vue?vue&type=template&id=60d3a37c&"
import script from "./tabCustomerTicketing.vue?vue&type=script&lang=js&"
export * from "./tabCustomerTicketing.vue?vue&type=script&lang=js&"
import style0 from "./tabCustomerTicketing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports